import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "timelineWrapper"]

  connect() {
    this.toggle()
  }

  toggle() {
    const showTimeline = this.selectTarget.value === 'true'

    if (this.hasTimelineWrapperTarget) {
      this.timelineWrapperTarget.classList.toggle('hidden', !showTimeline)
    }
  }
}
